/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetActorsResponseJson } from './get-actors-response-json';
import { GetActorsResult } from '../results/get-actors-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ActorDto } from '../models/actor-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetActorsResponse extends ResponseWithErrorGeneric<GetActorsResponseJson, GetActorsResult> implements IResponseWithErrorGeneric<GetActorsResult> {
  public actors: ActorDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetActorsResponse>) {
    super(response, GetActorsResult.Error);
    if (this.result !== GetActorsResult.Success) return;

    this.actors = this.body.actors.map(sr => new ActorDto(sr));
  }
  //</custom-body>
}
